export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const PAGE = "PAGE";
export const BREADCRUMB = "BREADCRUMB";